"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiKeyActivityState = exports.ApiKeyScope = void 0;
var ApiKeyScope;
(function (ApiKeyScope) {
    ApiKeyScope["Super"] = "super";
    ApiKeyScope["Read"] = "read";
    ApiKeyScope["Write"] = "write";
    ApiKeyScope["Internal"] = "internal";
    ApiKeyScope["Unrecognized"] = "unrecognized";
})(ApiKeyScope || (exports.ApiKeyScope = ApiKeyScope = {}));
var ApiKeyActivityState;
(function (ApiKeyActivityState) {
    ApiKeyActivityState["Created"] = "created";
    ApiKeyActivityState["Updated"] = "updated";
    ApiKeyActivityState["Deleted"] = "deleted";
    ApiKeyActivityState["Unrecognized"] = "unrecognized";
})(ApiKeyActivityState || (exports.ApiKeyActivityState = ApiKeyActivityState = {}));
